import { BlockParameters, PipelinePhase } from '@visualizer/types';
import { PipelineBlock } from '../PipelineBlock';
import { AddMetadata, BlockKeys } from '../BlockCatalog';
import CloseToDesignSchemesStage, { CloseToDesignSchemesStageParameters } from '../stages/filters/CloseToDesignSchemesStage';

export interface CloseToDesignSchemesBlockParameters extends BlockParameters, CloseToDesignSchemesStageParameters {}

@AddMetadata({
    type: BlockKeys.CloseToDesignSchemes,
    name: 'Close to Design Schemes',
    description: 'Keep sensors close to the geometry of the active design scheme set',
    visible: false,
    pipelinePhase: PipelinePhase.Post,
})
class CloseToDesignSchemesBlock extends PipelineBlock<CloseToDesignSchemesBlockParameters> {
    protected override serializeParams(): CloseToDesignSchemesBlockParameters {
        return {
            enabled: false,
            raycastMeshes: [],
            globalBox: undefined,
            maxDistance: this.getParams().maxDistance,
        };
    }

    protected override defineStages() {
        return [
            new CloseToDesignSchemesStage({
                raycastMeshes: this.getParams().raycastMeshes,
                globalBox: this.getParams().globalBox,
                maxDistance: this.getParams().maxDistance,
            }),
        ];
    }
}

export default CloseToDesignSchemesBlock;
